// extracted by mini-css-extract-plugin
export default {"CalendarInfo":"styles_CalendarInfo__4jDMD"};